import React from 'react'
import Parcel from 'single-spa-react/parcel' // https://github.com/single-spa/single-spa-react/releases/tag/v3.0.0

export const SingleSpaParcel = (props) => <Parcel {...props} />



// WEBPACK FOOTER //
// ./src/components/MfeParcels/SingleSpaParcel.js